import { useQuery } from '@tanstack/react-query';

import { fetchUsers } from '@/services/admin';

import type { IUsersListParams, IUsersListResponse } from '@/types/user';

export function useAdminUsers(params: IUsersListParams) {
  const { data, isLoading, error, refetch } = useQuery<IUsersListResponse, Error>({
    queryKey: ['adminUsers', params],
    queryFn: () => fetchUsers(params),
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: error?.message ?? null,
    refetch,
  };
}
